// Small project-owned stroke icon set (24×24, currentColor). Decorative by default
// (aria-hidden); give the surrounding control an accessible name instead.
import { svg } from './h.js';

const P = {
  monitor: ['M3 5h18v11H3z', 'M8 20h8', 'M12 16v4', 'M7 9l2 2-2 2', 'M11 13h4'],
  path: ['M5 19c0-4 3-5 7-5s7-1 7-5', 'M5 19h.01', 'M19 9h.01', 'M12 5l2-2 2 2', 'M14 3v6'],
  shield: ['M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z', 'M9 12l2 2 4-4'],
  chart: ['M4 20V10', 'M10 20V4', 'M16 20v-7', 'M22 20H2'],
  headset: ['M4 14v-2a8 8 0 0 1 16 0v2', 'M4 14h3v5H5a1 1 0 0 1-1-1z', 'M20 14h-3v5h2a1 1 0 0 0 1-1z', 'M17 19c0 1.5-2 2-5 2'],
  search: ['M11 4a7 7 0 1 1 0 14 7 7 0 0 1 0-14z', 'M21 21l-5-5'],
  check: ['M5 12.5l4.5 4.5L19 7.5'],
  file: ['M6 3h8l4 4v14H6z', 'M14 3v4h4', 'M9 12h6', 'M9 16h6'],
  network: ['M12 3v5', 'M5 16v-3h14v3', 'M12 8a2 2 0 1 0 0 .01', 'M5 16a2 2 0 1 0 0 .01', 'M19 16a2 2 0 1 0 0 .01', 'M12 13v3', 'M12 16a2 2 0 1 0 0 .01'],
  switch: ['M3 8h18v8H3z', 'M7 12h.01', 'M11 12h.01', 'M15 12h.01', 'M7 4l-3 4', 'M17 4l3 4'],
  router: ['M4 14h16v5H4z', 'M8 16.5h.01', 'M12 16.5h.01', 'M7 10a7 7 0 0 1 10 0', 'M9.5 12a3.5 3.5 0 0 1 5 0'],
  globe: ['M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18z', 'M3 12h18', 'M12 3c2.5 2.5 3.5 5.5 3.5 9s-1 6.5-3.5 9', 'M12 3c-2.5 2.5-3.5 5.5-3.5 9s1 6.5 3.5 9'],
  server: ['M4 4h16v6H4z', 'M4 14h16v6H4z', 'M8 7h.01', 'M8 17h.01'],
  lock: ['M6 11h12v9H6z', 'M8.5 11V8a3.5 3.5 0 0 1 7 0v3'],
  gear: ['M12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z', 'M12 2v3', 'M12 19v3', 'M2 12h3', 'M19 12h3', 'M4.9 4.9l2.1 2.1', 'M17 17l2.1 2.1', 'M4.9 19.1L7 17', 'M17 7l2.1-2.1'],
  firewall: ['M3 5h18v14H3z', 'M3 10h18', 'M3 15h18', 'M9 5v5', 'M15 10v5', 'M9 15v4'],
  cloud: ['M7 18a4 4 0 0 1-.5-8A6 6 0 0 1 18 9a4.5 4.5 0 0 1-.5 9z'],
  mail: ['M3 6h18v12H3z', 'M3 7l9 6 9-6'],
  user: ['M12 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8z', 'M4 20c1.5-3.5 4.5-5 8-5s6.5 1.5 8 5'],
  eye: ['M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z', 'M12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z'],
  eyeOff: ['M9.9 9.9a3 3 0 1 0 4.2 4.2', 'M10.7 5.1A10.4 10.4 0 0 1 12 5c6.5 0 10 7 10 7a13 13 0 0 1-1.7 2.7', 'M6.6 6.6A13.5 13.5 0 0 0 2 12s3.5 7 10 7a9.7 9.7 0 0 0 5.4-1.6', 'M2 2l20 20'],
  trend: ['M22 7l-8.5 8.5-5-5L2 17', 'M16 7h6v6'],
  arrowRight: ['M5 12h14', 'M13 6l6 6-6 6'],
  arrowLeft: ['M19 12H5', 'M11 6l-6 6 6 6'],
  play: ['M8 5l11 7-11 7z'],
  pause: ['M8 5v14', 'M16 5v14'],
  replay: ['M4 12a8 8 0 1 0 2.3-5.6', 'M4 4v4h4'],
  menu: ['M4 7h16', 'M4 12h16', 'M4 17h16'],
  close: ['M6 6l12 12', 'M18 6L6 18'],
  ticket: ['M4 7h16v3a2 2 0 0 0 0 4v3H4v-3a2 2 0 0 0 0-4z', 'M10 7v10'],
  clip: ['M16 8l-6.5 6.5a2 2 0 0 0 2.8 2.8L19 10.6a4 4 0 0 0-5.7-5.7L6.6 11.6a6 6 0 0 0 8.5 8.5'],
  sparkle: ['M12 3l2 6 6 2-6 2-2 6-2-6-6-2 6-2z'],
};

export function icon(name, { size = 20, cls = '', stroke = 2 } = {}) {
  return svg('svg', { class: `rz-ic ${cls}`, width: size, height: size, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': stroke, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true', focusable: 'false' },
    (P[name] || P.sparkle).map((d) => svg('path', { d })));
}
